import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, setToken, getToken, fetchMediaToken, setMediaToken } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  const activate = useCallback(async (u) => {
    try { await fetchMediaToken(); } catch (_) {}
    setUser(u);
  }, []);

  useEffect(() => {
    if (!getToken()) { setUser(false); return; }
    api.get("/auth/me").then((r) => activate(r.data)).catch(() => { setToken(null); setUser(false); });
  }, [activate]);

  useEffect(() => {
    if (!user) return;
    const t = setInterval(() => fetchMediaToken().catch(() => {}), 90 * 60 * 1000);
    return () => clearInterval(t);
  }, [user]);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setToken(data.token);
    await activate(data.user);
  }, [activate]);

  const logout = useCallback(async () => {
    try { await api.post("/auth/logout"); } catch (_) {}
    setToken(null);
    setMediaToken("");
    setUser(false);
  }, []);

  return <AuthContext.Provider value={{ user, login, logout, setUser: activate }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
